import React from 'react';
import { Droplets, Trash2, FileSearch, Code, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Platform = () => {
    const navigate = useNavigate();

    const projects = [
        {
            id: "01",
            title: "Vibe Coding Bootcamp",
            icon: Code,
            color: "text-primary",
            bgColor: "bg-primary/10",
            desc: "Programa gratuito de 10 semanas que enseña a jóvenes de Iztacalco a construir software usando IA generativa. Reactivación microeconómica local.",
            features: [
                "Desarrollo web con asistencia de IA",
                "Proyectos reales para comercios locales",
                "Freelancing y empleo tech local"
            ],
            status: "Próximamente · Enero 2026",
            link: "/vibe-coding"
        },
        {
            id: "02",
            title: "Proyecto Hidrosensorial",
            icon: Droplets,
            color: "text-blue-400",
            bgColor: "bg-blue-500/10",
            desc: "Red ciudadana de monitoreo hídrico. Sensores IoT de presión para mapear en tiempo real el estrés hídrico y detectar fugas invisibles en la red.",
            features: [
                "Dashboard público de suministro",
                "Detección temprana de fugas",
                "Auditoría forense de la red"
            ],
            status: "En investigación"
        },
        {
            id: "03",
            title: "Iztacalco Limpio",
            icon: Trash2,
            color: "text-emerald-400",
            bgColor: "bg-emerald-500/10",
            desc: "Programa de gestión inteligente de residuos. Mapeo de puntos de acumulación ilegal, optimización de rutas de recolección y educación ambiental.",
            features: [
                "Mapa de tiraderos clandestinos",
                "Seguimiento de rutas de camiones",
                "Reciclaje comunitario"
            ],
            status: "En planeación"
        },
        {
            id: "04",
            title: "Transparentia",
            icon: FileSearch,
            color: "text-amber-400",
            bgColor: "bg-amber-500/10",
            desc: "Auditoría algorítmica del gasto público. Análisis de 919+ contratos gubernamentales para detectar anomalías y fomentar la rendición de cuentas.",
            features: [
                "Visualización de $1.84B MXN en contratos",
                "Detección de concentración de mercado",
                "Periodismo de datos libre"
            ],
            status: "Activo",
            link: "/app"
        }
    ];

    return (
        <section id="plataforma" className="py-24 bg-background">
            <div className="container mx-auto px-6">
                <div className="text-center mb-16">
                    <span className="text-primary font-mono text-sm tracking-widest uppercase mb-4 block">LABORATORIO URBANO</span>
                    <h2 className="text-4xl md:text-5xl font-display font-bold text-white mb-6">Proyectos en Acción</h2>
                    <p className="text-zinc-500 max-w-2xl mx-auto">
                        Cuatro líneas de trabajo para transformar Iztacalco desde la ciudadanía, los datos y la tecnología.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
                    {projects.map((p) => (
                        <div
                            key={p.id}
                            className="bg-surface border border-zinc-800 p-8 rounded-xl hover:border-primary/30 transition-all group cursor-pointer"
                            onClick={() => p.link && navigate(p.link)}
                        >
                            <div className="flex justify-between items-start mb-6">
                                <div className={`p-3 rounded-lg ${p.bgColor} ${p.color}`}>
                                    <p.icon size={24} />
                                </div>
                                <div className="flex items-center gap-2">
                                    <span className={`text-xs font-mono px-2 py-1 rounded ${p.status === "Activo"
                                            ? "bg-primary/20 text-primary"
                                            : "bg-zinc-800 text-zinc-500"
                                        }`}>
                                        {p.status}
                                    </span>
                                </div>
                            </div>
                            <h3 className="text-2xl font-bold text-white mb-4 group-hover:text-primary transition-colors">{p.title}</h3>
                            <p className="text-text-muted mb-6 min-h-[60px]">{p.desc}</p>
                            <ul className="space-y-2 mb-6">
                                {p.features.map((f, i) => (
                                    <li key={i} className="flex items-center gap-2 text-sm text-zinc-500 font-mono">
                                        <span className="w-1.5 h-1.5 bg-primary rounded-full"></span>
                                        {f}
                                    </li>
                                ))}
                            </ul>
                            {p.link && (
                                <div className="flex items-center gap-2 text-primary text-sm font-mono group-hover:gap-3 transition-all">
                                    Explorar <ArrowRight size={14} />
                                </div>
                            )}
                        </div>
                    ))}
                </div>

            </div>
        </section>
    );
};

export default Platform;
